'use client';

import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import { ProductLinePic } from '@/app/components/icons/ProductLinePic';

export const OfflineAvatarPlaceholderPreview: FC = () => {
  const t = useTranslations('tools.offlineAvatar');

  return (
    <div className="flex flex-col items-center gap-3 text-system-white32">
      <span className="flex size-12 items-center justify-center rounded-full border border-system-white12 bg-system-white04">
        <ProductLinePic className="size-5" />
      </span>
      <div className="text-center">
        <h1 className="font-semibold text-base text-system-white64">{t('title')}</h1>
        <p className="mt-1 max-w-[240px] text-system-white40 text-xs leading-5">{t('description')}</p>
      </div>
    </div>
  );
};
